<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'GtrModal',
  props: {
    title: { required: false, type: String, default: 'Title' },
    width: { required: false, type: Number, default: 450 },
    height: { required: false, type: [Number, String], default: '' },
    value: { required: true, type: Boolean, default: false },
    closable: { required: false, type: Boolean, default: false },
    scrollable: { required: false, type: Boolean, default: true },
    spaceActions: { required: false, type: Boolean, default: true },
    persistent: { required: false, type: Boolean, default: true }
  },
  data () {
    return {
      show: false
    }
  },
  computed: {
    isFullscreen (): boolean {
      return this.$vuetify.breakpoint.xsOnly
    },
    modalHeight () {
      if (this.isFullscreen) return ''
      return typeof this.height === 'number' ? this.height + 'px' : this.height
    },
    showClose (): boolean {
      // On mobile, show the X only if the parent can actually act on it;
      // otherwise non-dismissable modals (loaders, warnings) get a dead button.
      return this.closable || (this.isFullscreen && !!this.$listeners.close)
    }
  },
  watch: {
    value: {
      immediate: true,
      handler (newValue) {
        this.show = newValue
        this.$emit('change', newValue)
      }
    }
  }
})
</script>

<template>
  <v-dialog v-model="show" :persistent="persistent" :max-width="width" :fullscreen="isFullscreen" :scrollable="scrollable" @keydown.esc="$emit('close')">
    <v-card class="base-card base-card-no-outline" :class="{ 'gtr-modal--fullscreen': isFullscreen }" :style="{ height: modalHeight }">
      <v-card-title class="mb-6">
        <h1>{{ title }}</h1>
        <v-spacer></v-spacer>
        <v-btn v-if="showClose" link icon aria-label="Close" @click="() => $emit('close')">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <slot></slot>
      </v-card-text>
      <v-card-actions>
        <v-spacer v-if="spaceActions" />
        <slot name="actions"></slot>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
